export const saveGet = {
  methods: {
    saveGetAndMap(obj, orElse, map, ...keys) {
      if (!obj) {
        return orElse
      }

      let result = obj

      for (const key of keys) {
        if (result[key]) {
          result = result[key]
        } else {
          return orElse
        }
      }

      return map(result)
    },
    saveGetAndMapWithLog(obj, orElse, map, ...keys) {
      if (!obj) {
        console.warn('Object is null when trying to saveGet', obj, keys)
        return orElse
      }

      let result = obj

      for (const key of keys) {
        if (result[key]) {
          result = result[key]
        } else {
          console.warn(
            'Object has no property ' + key + ' trying to saveGet',
            obj,
            keys
          )
          return orElse
        }
      }

      return map(result)
    },
    saveGet(obj, orElse, ...keys) {
      return this.saveGetAndMap(obj, orElse, x => x, ...keys)
    },
    saveGetWithLog(obj, orElse, ...keys) {
      return this.saveGetAndMapWithLog(obj, orElse, x => x, ...keys)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/saveGet.js